import {CircularProgress} from "@mui/material";
import TranslateSafeLoadingButton from "../translate-safe-loading-button/TranslateSafeLoadingButton";
import {FC} from "react";

interface IProps {
    counter: number
    seconds: number
    buttonLabel: string
    handleOnSubmitClick: () => void
    color: 'primary' | 'secondary'
    disabled?: boolean
}

const ButtonWithProgress: FC<IProps> = (props) => {
    const calculateProgress = Math.floor((props.counter / props.seconds) * 100)

    return (
        <TranslateSafeLoadingButton variant='contained'
                                    color={props.color}
                                    loading={!!props.counter}
                                    disabled={!!props.disabled}
                                    onClick={props.handleOnSubmitClick}
                                    loadingIndicator={<CircularProgress size='25px'
                                                                        variant='determinate'
                                                                        value={calculateProgress}/>}
        >
            {props.buttonLabel}
        </TranslateSafeLoadingButton>
    )
}

export default ButtonWithProgress
